// React Router v6 only captures whole path segments, so a URL like
// /cnc-estimate/contactInfoId=18782/unitId=49499/jobNum=CC-1042 matched by
// /cnc-estimate/:contactInfoId/:unitId/:jobNum yields jobNum = "jobNum=CC-1042".
// Strip the leading "<key>=" so callers get the bare value; plain values pass through unchanged.
export function stripRouteParamKey(value, key) {
  if (typeof value !== "string") return value;
  const prefix = `${key}=`;
  return value.startsWith(prefix) ? value.slice(prefix.length) : value;
}
